import { productCardFields } from '../../config/endpoint-fields/product-card.fields';

export const productComparatorFields = [...productCardFields, 'classifications(FULL)'];
